import React from "react";
import ProductCard from "./ProductCard";
import "../styles/Section.css";

type Product = {
  id: string;
  title: string;
  image: string;
  status: "available" | "coming soon";
};

type SectionProps = {
  title: string;
  products: Product[];
  onProductClick: (id: string) => void;
};

const Section: React.FC<SectionProps> = ({
  title,
  products,
  onProductClick,
}) => {
  return (
    <section className="component-section">
      <div className="component-section-container">
        <h2>{title}</h2>
        <div className="component-section-flex">
          {products.map((product) => (
            <ProductCard
              key={product.id}
              title={product.title}
              id={product.id}
              image={product.image}
              status={product.status}
              onClick={() => {
                if (product.status === "available") {
                  onProductClick(product.id);
                }
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section;
